import React from 'react';
import styled from '@emotion/styled';
import { Content, NavigationConfiguration, Widget } from './apiService';
import { globalPadding } from './Layout/Layout';
import Scroller from './Scroller';
import { Box, Row, Text } from './styles';
import VitrineCard from './VitrineCard';
import { SpacingProps } from './withStyleSystem';
import PageOverlay from './styles/PageOverlay';

const Vitrine = ({ widget, eager = false }: { widget: Widget<'vitrine'>; eager?: boolean }) => {
  const {
    configuration: { items },
    display_title,
  } = widget;
  const [activeCardId, setActiveCardId] = React.useState<string | null>(null);

  const _items = [...items]
    .map(
      (
        {
          content_id: contentId,
          image: { path: image } = {},
          video_content: content,
          navigation_configuration: navigationConfiguration,
          title,
          description,
        },
        index,
      ) => ({
        id: `${content?.id || contentId || 'vitrine-item'}-${index}`,
        content,
        image,
        navigationConfiguration,
        title,
        description,
      }),
    )
    .filter(({ content, navigationConfiguration }) => navigationConfiguration?.navigation_type !== 'content' || !!content?.id);

  const row1 = _items.slice(0, 5);
  const row2 = _items.slice(5, 10);
  const row3 = _items.slice(10);

  return (
    <VitrineContainer>
      <Text variant="h2" weight="medium" mb={1}>
        {display_title}
      </Text>
      <PageOverlay visible={!!activeCardId} />
      <Scroller cancelPadding={globalPadding} arrows hoverOverflowVisibleOnDesktop scroll="visible">
        <VitrineRow items={row1} mb={0} activeCardId={activeCardId} onHoverChange={setActiveCardId} eager={eager} />
        <VitrineRow items={row2} mb={0} activeCardId={activeCardId} onHoverChange={setActiveCardId} />
        <VitrineRow items={row3} activeCardId={activeCardId} onHoverChange={setActiveCardId} />
      </Scroller>
    </VitrineContainer>
  );
};

const VitrineRow = ({
  items,
  activeCardId,
  onHoverChange,
  eager = false,
  ...spacingProps
}: {
  items: {
    id: string;
    content?: Content;
    image?: string;
    navigationConfiguration?: NavigationConfiguration;
    title?: string;
    description?: string;
  }[];
  activeCardId: string | null;
  onHoverChange: (id: string | null) => void;
  eager?: boolean;
} & SpacingProps) => (
  <Row cols={{ xs: 2, sm: 3, md: 4, lg: 5 }} {...spacingProps}>
    {items.map(({ id, content, image, navigationConfiguration, title, description }, index) => (
      <VitrineCard
        key={id}
        id={id}
        imagePath={image}
        content={content}
        navigationConfiguration={navigationConfiguration}
        title={title}
        description={description}
        active={activeCardId === id}
        eager={eager}
        priority={eager && index === 0}
        onHoverChange={onHoverChange}
      />
    ))}
  </Row>
);

const VitrineContainer = styled(Box)(() => ({
  position: 'relative',
}));

export default Vitrine;
